import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";
import queryString from "querystring";


let redux = reduxCreator.type('COMMENTS_TO_MODERATE').plugin(axiosPlugin, {template: "array"});

let fetchCommentsToModerateAction = redux.fetchActionGet();

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState.total--;
        if(newState.total < 0){
            newState.total = 0;
        }
    }
    return newState;
});

redux.reducerForType('UPDATE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState.total--;
        if(newState.total < 0){
            newState.total = 0;
        }
    }
    return newState;
});

export const fetchCommentsToModerate = (type, parentId, query, more = false) => fetchCommentsToModerateAction(`/users/me/moderation-comments/${type}/${parentId}?${queryString.stringify(query)}`,null,{more});
export const resetCommentsToModerate = () => redux.actions.reset();

export const commentsToModerate = redux.reducer();